
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import NotificationAlert from "react-notification-alert";
import { Col, Container, Row } from "reactstrap";
import AdminService from "../../../services/adminService";
import AdminListTable from "./ListTable";
import SecurityConstant from "../../../util/securityConstant";
import ReactBSAlert from "react-bootstrap-sweetalert";

class AdminList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      alert: null,
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
    this.confirmDeleteAlert = this.confirmDeleteAlert.bind(this);
  }

  componentDidMount() {
    AdminService.list(SecurityConstant.ROLE_ADMIN).then((response) => {
      this.setState({ list: response.data });
    });
  }

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
          <ReactBSAlert
              warning
              style={{display: "block"}}
              title="Are you sure?"
              onConfirm={() => this.delete(uniqueId)}
              onCancel={this.hideDeleteAlert}
              showCancel
              confirmBtnBsStyle="danger"
              confirmBtnText="Yes, delete it!"
              cancelBtnBsStyle="secondary"
              cancelBtnText="Cancel"
              btnSize=""
          >
            You won't be able to revert this!
          </ReactBSAlert>
      )
    });
  };

  delete(uniqueId) {
    AdminService.delete(uniqueId).then((response) => {
      this.notify(
        response.responseStatus.toLowerCase(),
        response.responseStatus,
        response.message
      );
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      AdminService.list(SecurityConstant.ROLE_ADMIN).then((response) => {
        this.setState({ list: response.data, alert:null });
      });
    });
  }

  hideDeleteAlert = () => {
    this.setState({
      alert: null
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  render() {
    const { adminList } = this.state.list;
    let obj = this;
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {this.state.alert}
        <SimpleHeader
          name="List"
          parentName="Users"
          heading="Xaregrowth"
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <AdminListTable
                adminComponentObj={obj}
                adminList={this.state.list}
                cardTitle="Users List"
                userRole={SecurityConstant.ROLE_ADMIN}
              />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default AdminList;
